module.exports = __webpack_public_path__ + "static/img/family.8f750ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/family.svg?data
// module id = k6FJ
// module chunks = 1